import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

import PackingListSelect from "@RequestFormV2/sections/PackingList/components/shared/PackingListSelect";
import { getPackingListFieldPath } from "@RequestFormV2/sections/PackingList/utils/fieldPaths";
import type { DangerousGoodsOption } from "@RequestFormV2/sections/PackingList/utils/dangerousGoodsOptions";

type DangerousGoodsSelectProps = {
  index: number;
  options: DangerousGoodsOption[];
  onChange: () => void;
};

export default function DangerousGoodsSelect({ index, options, onChange }: DangerousGoodsSelectProps) {
  const intl = useIntl();
  const { setValue } = useFormContext();

  const handleChange = (value: string | null) => {
    if (!value) {
      setValue(getPackingListFieldPath(index, "un_number"), "");
      setValue(getPackingListFieldPath(index, "is_dangerous_good"), false);
    } else {
      setValue(getPackingListFieldPath(index, "is_dangerous_good"), true);
    }
    onChange();
  };

  return (
    <div className="rfv2-packing-list-table__dangerous-goods">
      <PackingListSelect
        size="sm"
        isClearable
        name={getPackingListFieldPath(index, "dangerous_good_value")}
        options={options}
        placeholder={intl.formatMessage({
          id: "request-form.packing-list.selectDgClass",
          defaultMessage: "Select DG class",
        })}
        onChange={handleChange}
      />
    </div>
  );
}
